const TEAM_STATUS = {
  // 开放编辑状态 不可删除队伍状态
  EDIT: 2,
  // 锁定状态
  LOCKED: 1,
  // 初始状态
  UNLOCKED: 0
};

const CLICK_APPLY_GAME = {
  YES: 1,
  NOT: 0
};

// 0 pending      1 pass   2 failed   3 cancel
const TEAM_APPLICATION_STATUS = {
  PASS: "1",
  REJECT: "2",
  PENDING: "0",
  CANCEL: "3"
};

// 0 是环节主体文案 1 是简介 2 环节提交显示的文案
const PARAGRAPHTYPE = {
  SUMMARY: 1,
  DETAIL: 0,
  FEEDBACK: 2
};

// 0 官网  1 cms inputsource

const INPUTSOURCE = {
  CMS: 1,
  WWW: 0
};

// input view type 0 文本 1 文件上传  2提交按钮  3下拉框
const INPUTVIEWTYPE = {
  TEXT: 0,
  UPLOAD: 1,
  SUBMIT: 2,
  SELECT: 3,
  RADIO: 4,
  // 参赛反馈特殊的radio
  RADIO_FEEDBACK: 7,
  DIVISION: 5,
  // 技术方向下拉选择
  TECH_DIRECTION_SELECT: 8,
  TEXT_AREA: 9,
  TIME_RESERVATION: 10,
  ONLINE_EXCEL: 11,
  CHOOSE_JOB: 12,
  CONTACT_INFORMATION: 13,
  PARTICIPATING_EXPERIENCE: 14,
  RECRUITMENT_STATUS: 15,
  UPLOAD_DOCKER_FILE: 16,
  FEEDBACK_DOCKER_PROGRESS_STATUS: 17,
  DOCKER_PERFORMANCE_FEEDBACK: 18,
  PERSONAL_INFO: 19
};

// 带选择项的 input
const OPTIONAL_COMPONENTS = [
  INPUTVIEWTYPE.RADIO,
  INPUTVIEWTYPE.RADIO_FEEDBACK,
  INPUTVIEWTYPE.SELECT,
  INPUTVIEWTYPE.DIVISION,
  INPUTVIEWTYPE.TECH_DIRECTION_SELECT
];

// input value type : 0 string 1 int
const INPUTVALUETYPE = {
  STRING: 0,
  INT: 1
};

const EVENT_TYPE = {
  TEAM: 0,
  PERSON: 1
};

const CAPTAIN = "CAPTAIN";

// 参加比赛的主体类型 队伍/个人
const SOURCE_TYPE = {
  TEAM: "Gteam",
  PERSON: "Account"
};

// 比赛设置职位人数限制状态
const EVENT_POSITION_STATUS = {
  OK: 1,
  NOTOK: 0
};

const PHONE_PREFIX = [
  86,
  1,
  1242,
  1246,
  1264,
  1268,
  1345,
  1441,
  1664,
  1670,
  1671,
  1758,
  1784,
  1787,
  1809,
  1876,
  1890,
  20,
  212,
  213,
  216,
  218,
  220,
  221,
  223,
  224,
  225,
  226,
  227,
  228,
  229,
  230,
  231,
  232,
  233,
  234,
  235,
  236,
  237,
  239,
  241,
  242,
  243,
  244,
  247,
  248,
  249,
  251,
  252,
  253,
  254,
  255,
  256,
  257,
  258,
  260,
  261,
  262,
  263,
  264,
  265,
  266,
  267,
  268,
  27,
  30,
  31,
  32,
  327,
  33,
  331,
  34,
  350,
  351,
  352,
  353,
  354,
  355,
  356,
  357,
  358,
  359,
  36,
  370,
  371,
  372,
  373,
  374,
  375,
  376,
  377,
  378,
  380,
  381,
  386,
  39,
  40,
  41,
  420,
  421,
  423,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  501,
  502,
  503,
  504,
  505,
  506,
  507,
  509,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  591,
  592,
  593,
  594,
  595,
  596,
  597,
  598,
  599,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  673,
  674,
  675,
  676,
  677,
  679,
  682,
  684,
  685,
  689,
  7,
  81,
  82,
  84,
  850,
  852,
  853,
  855,
  856,
  880,
  886,
  90,
  91,
  92,
  93,
  94,
  95,
  960,
  961,
  962,
  963,
  964,
  965,
  966,
  967,
  968,
  971,
  972,
  973,
  974,
  976,
  977,
  98,
  992,
  993,
  994,
  995
];
const CHINA_PHONE = /^[1]([3-9])[0-9]{9}$/;
const FOREIGN_PHONE = /^\d{7,20}$/;
const DEFAULT_AVATAR = "https://rm-static.djicdn.com/default/default-member-avatar-.png@!250";
const RESET_PASSWORD_PRO = "https://account.dji.com/reset?appId=robomasternn";
const RESET_PASSWORD_DBETA = "https://account.dbeta.me/reset?appId=robomastern";

const BASE_COUNTRY_OPS = [
  {
    value: "中国",
    label: "中国",
    enLabel: "China",
    children: [
      {
        value: "北京市",
        label: "北京",
        enLabel: "Beijing"
      },
      {
        value: "天津市",
        label: "天津",
        enLabel: "Tianjin"
      },
      {
        value: "上海市",
        label: "上海",
        enLabel: "Shanghai"
      },
      {
        value: "重庆市",
        label: "重庆",
        enLabel: "Chongqing"
      },
      {
        value: "河北省",
        label: "河北",
        enLabel: "Hebei"
      },
      {
        value: "山西省",
        label: "山西",
        enLabel: "Shanxi"
      },
      {
        value: "辽宁省",
        label: "辽宁",
        enLabel: "Liaoning"
      },
      {
        value: "吉林省",
        label: "吉林",
        enLabel: "Jilin"
      },
      {
        value: "黑龙江省",
        label: "黑龙江",
        enLabel: "Heilongjiang"
      },
      {
        value: "江苏省",
        label: "江苏",
        enLabel: "Jiangsu"
      },
      {
        value: "浙江省",
        label: "浙江",
        enLabel: "Zhejiang"
      },
      {
        value: "安徽省",
        label: "安徽",
        enLabel: "Anhui"
      },
      {
        value: "福建省",
        label: "福建",
        enLabel: "Fujian"
      },
      {
        value: "江西省",
        label: "江西",
        enLabel: "Jiangxi"
      },
      {
        value: "山东省",
        label: "山东",
        enLabel: "Shandong"
      },
      {
        value: "河南省",
        label: "河南",
        enLabel: "Henan"
      },
      {
        value: "湖北省",
        label: "湖北",
        enLabel: "Hubei"
      },
      {
        value: "湖南省",
        label: "湖南",
        enLabel: "Hunan"
      },
      {
        value: "广东省",
        label: "广东",
        enLabel: "Guangdong"
      },
      {
        value: "海南省",
        label: "海南",
        enLabel: "Hainan"
      },
      {
        value: "四川省",
        label: "四川",
        enLabel: "Sichuan"
      },
      {
        value: "贵州省",
        label: "贵州",
        enLabel: "Guizhou"
      },
      {
        value: "云南省",
        label: "云南",
        enLabel: "Yunnan"
      },
      {
        value: "陕西省",
        label: "陕西",
        enLabel: "Shaanxi"
      },
      {
        value: "甘肃省",
        label: "甘肃",
        enLabel: "Gansu"
      },
      {
        value: "青海省",
        label: "青海",
        enLabel: "Qinghai"
      },
      {
        value: "内蒙古自治区",
        label: "内蒙古",
        enLabel: "Inner Mongoria"
      },
      {
        value: "广西壮族自治区",
        label: "广西",
        enLabel: "Guangxi"
      },
      {
        value: "西藏自治区",
        label: "西藏",
        enLabel: "Tibet"
      },
      {
        value: "宁夏回族自治区",
        label: "宁夏",
        enLabel: "Ningxia"
      },
      {
        value: "新疆维吾尔自治区",
        label: "新疆",
        enLabel: "Xinjiang"
      },
      {
        value: "香港特别行政区",
        label: "香港",
        enLabel: "Hong Kong"
      },
      {
        value: "澳门特别行政区",
        label: "澳门",
        enLabel: "Macao"
      },
      {
        value: "台湾省",
        label: "台湾",
        enLabel: "Taiwan"
      },
      {
        value: "中国不限地区",
        label: "不限地区",
        enLabel: "No Limitation"
      }
    ]
  },
  {
    value: "美国",
    label: "美国",
    enLabel: "America"
  },
  {
    value: "日本",
    label: "日本",
    enLabel: "Japan"
  },
  {
    value: "加拿大",
    label: "加拿大",
    enLabel: "Canada"
  },
  {
    value: "新加坡",
    label: "新加坡",
    enLabel: "Singapore"
  },
  {
    value: "澳大利亚",
    label: "澳大利亚",
    enLabel: "Australia"
  },
  {
    value: "欧洲地区",
    label: "欧洲地区",
    enLabel: "Europe"
  },
  {
    value: "非洲地区",
    label: "非洲地区",
    enLabel: "Africa"
  },
  {
    value: "南美洲地区",
    label: "南美洲地区",
    enLabel: "South America"
  },
  {
    value: "全球不限地区",
    label: "不限地区",
    enLabel: "No Limitation"
  }
];

const COUNTRIES = {
  zh: [
    {
      value: "CHN",
      label: "中国"
    },
    {
      value: "USA",
      label: "美国"
    },
    {
      value: "JPN",
      label: "日本"
    },
    {
      value: "CAN",
      label: "加拿大"
    },
    {
      value: "SGP",
      label: "新加坡"
    },
    {
      value: "AUS",
      label: "澳大利亚"
    },
    {
      value: "EUR",
      label: "欧洲地区"
    },
    {
      value: "AFR",
      label: "非洲地区"
    },
    {
      value: "SA",
      label: "南美洲地区"
    },
    {
      value: "OTHERS",
      label: "其他"
    }
  ],
  en: [
    {
      value: "CHN",
      label: "China"
    },
    {
      value: "USA",
      label: "United States"
    },
    {
      value: "JPN",
      label: "Japan"
    },
    {
      value: "CAN",
      label: "Canada"
    },
    {
      value: "SGP",
      label: "Singapore"
    },
    {
      value: "AUS",
      label: "Australia"
    },
    {
      value: "EUR",
      label: "European region"
    },
    {
      value: "AFR",
      label: "African region"
    },
    {
      value: "SA",
      label: "South America"
    },
    {
      value: "OTHERS",
      label: "Others"
    }
  ]
};

// 环节区分 0 报名环节  1普通环节 3 规则测评环节
const STAGE_TYPE = {
  LOOP: 0,
  NORMAL: 1,
  // 测评环节
  JUDGE: 3,
  // 反馈环节
  FEEDBACK: 4,
  // 面试预约环节
  MEETING: 5
};

const STAGE_STATUS = {
  // 进行中
  PROGRESS: "PROGRESS",
  // 通过
  PASS: "PASS",
  // 不通过
  FAIL: "FAIL",
  // 原始状态
  PENDING: "PENDING"
};

const MESSAGE = {
  // 报名号提示
  CODE: 1,
  // 最终赛区提示
  DIVISION: 2,
  // 已读
  READ: "read"
};

// 队伍类型
const TEAM_TYPE = {
  // 战队
  TEAM: 0,
  // 联队
  CONSORTIUM: 1
};

const USER_SHOW = {
  // 显示
  SHOW: 1,
  // 不显示
  HIDDEN: 0
};
// 参赛反馈缓解的 参赛反馈radio “是”的约定值
const FEEDBACK_VALUE = "1";

const QUIZ_STATUS = {
  JUDGED: 3,
  STARTED: 2
};

const QUIZ_SCORE_RULE = {
  // 最后一次分数有效
  LAST: 0,
  // 最高分有效
  HIGHEST: 1
};

const SERVER_STATUS = {
  SUCCESS: 0
};

const SERVER_CUSTOM_ERROR_CODE = {
  NEED_LOGIN: 11, // 登陆失效，需要登陆
  VALIDATE_FAILED: 17 // 校验失败，通常是该队员已经在团队里导致的
};

const APP_NORMALIZED_ENV_MAP = {
  DEV: "test",
  STAG: "staging",
  PROD: "production"
};

const CACHE_REGISTRATION_CENTER_GAME_LIST = "cacheGameList";

// 需要进行个人信息确认的赛事类型id
const CONFIRM_PERSONAL_INFO_GAME_CATEGORY_IDS = ["9", "3", "1", "2", "21"];

// 论坛战队有管理权限的职位
const BBS_TEAM_POSITION_WITH_MANAGEMENT = ["Captain", "Teacher"];

export default {
  EVENT_TYPE,
  TEAM_APPLICATION_STATUS,
  PARAGRAPHTYPE,
  INPUTSOURCE,
  INPUTVIEWTYPE,
  INPUTVALUETYPE,
  OPTIONAL_COMPONENTS,
  TEAM_STATUS,
  CAPTAIN,
  EVENT_POSITION_STATUS,
  PHONE_PREFIX,
  CHINA_PHONE,
  FOREIGN_PHONE,
  DEFAULT_AVATAR,
  CLICK_APPLY_GAME,
  BASE_COUNTRY_OPS,
  STAGE_TYPE,
  STAGE_STATUS,
  MESSAGE,
  TEAM_TYPE,
  USER_SHOW,
  RESET_PASSWORD_PRO,
  RESET_PASSWORD_DBETA,
  FEEDBACK_VALUE,
  QUIZ_STATUS,
  QUIZ_SCORE_RULE,
  SOURCE_TYPE,
  COUNTRIES,
  SERVER_CUSTOM_ERROR_CODE,
  SERVER_STATUS,
  APP_NORMALIZED_ENV_MAP,
  CACHE_REGISTRATION_CENTER_GAME_LIST,
  CONFIRM_PERSONAL_INFO_GAME_CATEGORY_IDS,
  BBS_TEAM_POSITION_WITH_MANAGEMENT
};



// WEBPACK FOOTER //
// ./src/helper/const.js